var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 46,
    viewBox: "0 0 90 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15686_254131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 22.9992C90 29.3512 87.4763 35.1014 83.3957 39.2636C79.3152 43.4258 73.6778 46 67.4503 46H22.5481C10.0948 46 0 35.7016 0 22.9992C0 16.6471 2.52369 10.8986 6.60425 6.73637C10.6848 2.57418 16.3222 0 22.5481 0H67.4503C79.9052 0 90 10.2967 90 22.9992Z",
    fill: "#2E26FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4253 12.382C21.335 12.382 20.4531 12.7418 20.4531 13.1833V33.1847C20.4531 33.6263 21.335 33.9861 22.4253 33.9861C23.5155 33.9861 24.3974 33.6263 24.3974 33.1847V13.1833C24.3974 12.7418 23.5155 12.382 22.4253 12.382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.947 12.1693C14.8728 12.0221 13.9588 12.251 13.8947 12.6926L11.2652 32.5305C11.2011 32.9721 12.0348 33.4463 13.1091 33.5935C14.1833 33.7407 15.0972 33.5117 15.1614 33.0702L17.7909 13.2323C17.855 12.7907 17.0213 12.3165 15.947 12.1693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9006 12.1693C27.8263 12.3165 27.0086 12.7907 27.0567 13.2323L29.6862 33.0538C29.7504 33.4954 30.6643 33.7244 31.7385 33.5772C32.8128 33.43 33.6305 32.9557 33.5824 32.5141L30.9529 12.6926C30.9048 12.251 29.9748 12.0221 28.9006 12.1693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0312 23.045C37.0312 24.1571 37.384 25.0566 37.8169 25.0566H52.7923C53.2252 25.0566 53.578 24.1571 53.578 23.045C53.578 21.9329 53.2252 21.0334 52.7763 21.0334H37.8009C37.384 21.0334 37.0312 21.9329 37.0312 23.045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.821 29.9302C36.6767 31.0259 36.9011 31.9581 37.3341 32.0235L52.1652 34.0678C52.5981 34.1333 53.063 33.2828 53.2073 32.1871C53.3517 31.0913 53.1272 30.1591 52.6943 30.0937L37.8632 28.0494C37.4303 28.0004 36.9653 28.8344 36.821 29.9302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8234 16.1597C36.9677 17.2555 37.4326 18.0896 37.8655 18.0405L52.6966 15.9962C53.1296 15.9308 53.354 14.9986 53.2097 13.9028C53.0654 12.8071 52.6004 11.973 52.1675 12.0221L37.3364 14.0664C36.9035 14.1154 36.663 15.064 36.8234 16.1597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5576 11.5479C61.3045 11.5479 56.2539 16.7158 56.2539 23.0777C56.2539 29.4396 61.3205 34.6075 67.5576 34.6075C73.7947 34.6075 78.8613 29.4396 78.8613 23.0777C78.8774 16.7158 73.8107 11.5479 67.5576 11.5479ZM67.5576 30.4535C63.5652 30.4535 60.3265 27.1499 60.3265 23.0777C60.3265 19.0055 63.5652 15.7019 67.5576 15.7019C71.55 15.7019 74.7888 19.0055 74.7888 23.0777C74.7888 27.1499 71.55 30.4535 67.5576 30.4535Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15686_254131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeo);
export default __webpack_public_path__ + "static/media/meo.986b852faefb1779adc1dcbad69d62bc.svg";
export { ForwardRef as ReactComponent };